import { TSeasonDef } from '../mythicPlus';

export const SEASONS: TSeasonDef[] = [];
